import { axios } from '../util/axios'

const API_ENDPOINT = '/v1/accounts/documents'

export const updateLegalDocument = (token, userType, legalDocument) => {
  if (!token)
    return new Promise((resolve, reject) => {
      return reject('No token')
    })

  const bodyRequest = { token, userType, legalDocument }

  return axios.patch(API_ENDPOINT, bodyRequest)
}
